module.exports = __webpack_public_path__ + "static/media/kitten.74ea254b.jpg";